<template>
    <div :data-component="$options.name">
        <transition
            enter-active-class="transition-all ease-linear duration-300"
            enter-from-class="-translate-y-100 opacity-0"
            leave-active-class="opacity-0 -translate-y-100 transition duration-300"
        >
            <div
                v-show="visible"
                ref="nudge"
                class="bg-color-neutral-black w-[332px] h-fit flex flex-row py-16 rounded-2xl shadow ms-nudge absolute bottom-full z-popup"
            >
                <div
                    class="h-40 w-40 rounded-full self-center mx-16 bg-sweetcorn flex justify-center items-center shrink-0"
                >
                    <ms-bell class="h-30 w-30 ms-nudge__icon" />
                </div>
                <div class="text-color-neutral-white text-text-desktop w-fit self-center break-words-all">
                    <slot />
                </div>
                <div
                    class="flex justify-center items-start cursor-pointer mx-16 text-color-neutral-white shrink-0"
                    data-jest-close
                    @click="closeNudge"
                >
                    <ms-close class="h-24 w-24 self-center" />
                </div>
            </div>
        </transition>
    </div>
</template>

<script lang="ts" src="./MsNudge.ts" />
<style scoped lang="scss" src="./MsNudge.scss" />
